import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';

import { ComingSoonPageComponent } from './coming-soon-page.component';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from "../../pipes/pipes.module";
import { SuccessBlockModule } from "../success-block/success-block.module";


@NgModule({
  declarations: [
    ComingSoonPageComponent
  ],
  exports: [
    ComingSoonPageComponent
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    DirectivesModule,
    TranslateModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    SuccessBlockModule
  ]
})
export class ComingSoonPageModule { }
